module.exports = __webpack_public_path__ + "img/credits-doubts.897f4036.svg";